import * as React from "react";

const CurrencyNumber: React.FunctionComponent<{
    value: number,
    prefix?: string
}> = ({ value, prefix }) => {
    return <React.Fragment>{prefix}${Number(value || 0)}</React.Fragment>
}

export default CurrencyNumber;